module.exports = __webpack_public_path__ + "media/images/redesign-images/home-new/business-37d211564f32b25e8c061a1d19319e7a.jpg";